var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50052 10C10.8892 10 12.015 8.88071 12.015 7.5C12.015 6.11929 10.8892 5 9.50052 5C8.11181 5 6.98604 6.11929 6.98604 7.5C6.98604 8.88071 8.11181 10 9.50052 10Z",
    fill: "#2A9DF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.110693 8.09038C-0.0370209 7.70873 -0.0368934 7.28563 0.11105 6.90408C1.56359 3.15788 5.21916 0.5 9.49911 0.5C13.7812 0.5 17.4382 3.16051 18.8893 6.90962C19.037 7.29127 19.0369 7.71437 18.889 8.09593C17.4364 11.8421 13.7808 14.5 9.5009 14.5C5.21884 14.5 1.56177 11.8395 0.110693 8.09038ZM13.5241 7.5C13.5241 9.70914 11.7228 11.5 9.5009 11.5C7.27896 11.5 5.47772 9.70914 5.47772 7.5C5.47772 5.29086 7.27896 3.5 9.5009 3.5C11.7228 3.5 13.5241 5.29086 13.5241 7.5Z",
    fill: "#2A9DF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEye);
export default __webpack_public_path__ + "static/media/ic-eye.2b054216de831c5b883f1c7a8530846b.svg";
export { ForwardRef as ReactComponent };